var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselComs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 404.52 404.52",
    xmlSpace: "preserve",
    fill: "#008A95",
    transform: "rotate(0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 2.4270959999999997
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#008A95"
    },
    d: "M353.647,0H50.869C23.754,0,1.694,22.06,1.694,49.176v198.617c0,27.115,22.06,49.176,49.176,49.176 h165.814v95.547c0,5.01,3.113,9.492,7.807,11.244c1.368,0.51,2.786,0.756,4.19,0.756c3.415,0,6.748-1.459,9.073-4.143 l89.575-103.404h26.317c27.115,0,49.175-22.06,49.175-49.176V49.176C402.822,22.06,380.762,0,353.647,0z M378.822,247.793 c0,13.881-11.293,25.176-25.175,25.176c0,0-31.047,0.008-31.23,0c-3.547-0.166-7.133,1.25-9.639,4.143l-72.093,83.225v-75.367 c0-6.627-5.373-12-12-12H50.869c-13.882,0-25.176-11.295-25.176-25.176V49.176C25.694,35.295,36.987,24,50.869,24h302.777 c13.882,0,25.175,11.295,25.175,25.176V247.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#008A95"
    },
    d: "M336.627,79.152H67.89c-6.627,0-12,5.373-12,12c0,6.627,5.373,12,12,12h268.737 c6.627,0,12-5.373,12-12C348.627,84.525,343.255,79.152,336.627,79.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#008A95"
    },
    d: "M336.627,136.484H67.89c-6.627,0-12,5.373-12,12c0,6.627,5.373,12,12,12h268.737 c6.627,0,12-5.373,12-12C348.627,141.857,343.255,136.484,336.627,136.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#008A95"
    },
    d: "M195.092,193.814H67.89c-6.627,0-12,5.373-12,12c0,6.627,5.373,12,12,12h127.203 c6.627,0,12-5.373,12-12C207.092,199.188,201.72,193.814,195.092,193.814z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselComs);
export default __webpack_public_path__ + "static/media/CarouselComs.a6385ffc81e01db3d881e75b92ea67ad.svg";
export { ForwardRef as ReactComponent };